import { Config } from "../../Config";
import { Word } from "../../stores/word/Word";
import { IWordService } from "./IWordService";
import { WordCsvParser } from "./WordCsvParser";

export class WordService implements IWordService {
  constructor(private googleSheetsUrl: string) {}

  getWords(wordsCallback: (words: Word[]) => void) {
    const prodConfig = {
      headers: {
        Accept: "text/plain",
      },
    };
    const noCorsConfig = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    const fetchConfig = Config.isLocalDev() ? noCorsConfig : prodConfig;

    fetch(this.googleSheetsUrl, fetchConfig)
      .then(
        (response) => {
          return response.text().then(
            (text) => {
              if (!text || text.length == 0) wordsCallback([]);
              else wordsCallback(this.processCsv(text));
            },
            (rejected) => {
              console.error(rejected);
              wordsCallback([]);
            }
          );
        },
        (rejectedReason) => {
          console.error(rejectedReason);
          wordsCallback([]);
        }
      )
      .catch((error) => {
        console.error(error);
        wordsCallback([]);
      });
  }

  private processCsv(text: string): Word[] {
    return text
      .split("\n")
      .slice(1) // skip the header row
      .map((line) => {
        const columns = line.split(",");
        const wordName = columns[0];

        columns.shift();

        return WordCsvParser.parseWordCsvLineFromGoogleSheets(
          wordName,
          columns
        );
      });
  }
}



// WEBPACK FOOTER //
// ./services/word/WordService.ts